import React from "react";

/**
 * @param {Array} columns - Array of objects defining column headers and rendering logic
 * @param {Array} data - The raw data array to map over
 * @param {String} emptyMessage - Text to show when data is empty
 * @param {Function} onRowClick - Optional handler for clicking a row
 * @param {Boolean} showRowNumber - Whether to show row numbers
 * @param {Object} pagination - Pagination info (page, limit, totalRecords, totalPages) for row numbering
 */
const GenericTable = ({ columns, data, onRowClick, showRowNumber = true, pagination }) => {
  const page = pagination?.page || 1;
  const limit = pagination?.limit || data?.length || 10;
  return (
    <div className="w-full overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200">
      <table
        className="w-full table-auto text-sm text-left rtl:text-right text-gray-500"
        style={{ tableLayout: "auto" }}
      >
        <thead className="text-xs text-gray-700 uppercase bg-gray-50">
          <tr className="bg-gray-100 border-b border-gray-200">
            {/* Header Row */}
            {showRowNumber && (
              <th className="px-4 py-3 font-semibold text-gray-700 w-12">#</th>
            )}
            {columns.map((col, index) => (
              <th
                key={index}
                scope="col"
                className={`px-4 py-3 font-semibold text-gray-700 ${col.className || ""}`}
                style={col.style}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(data && data.length > 0) && (
            data.map((row, rowIndex) => (
              <tr
                key={row.id || rowIndex}
                onClick={() => onRowClick && onRowClick(row)}
                className={`border-b hover:bg-gray-50 transition-colors last:border-b-0 ${onRowClick ? "cursor-pointer" : ""}`}
              >
                {/* Data Cells */}
                {showRowNumber && (
                  <td className="px-4 py-3 text-gray-500 font-medium">
                    {(page - 1) * limit + rowIndex + 1}
                  </td>
                )}
                {columns.map((col, colIndex) => (
                  <td
                    key={`${rowIndex}-${colIndex}`}
                    className={`px-4 py-3 text-gray-800 align-middle ${col.cellClassName || ""}`}
                  >
                    {/* Logic: If 'render' function exists, call it. Otherwise, use 'accessor' key */}
                    {col.render
                      ? col.render(row, rowIndex)
                      : row[col.accessor] || "-"}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default GenericTable;